import type { ComboboxOption } from '@eureca/ui';
import type {
  JobEditConditionsPageProps,
  JobEditConditionsValues,
} from './JobEditConditionsPage.component';

export const mockStateOptions: ComboboxOption[] = [
  { value: 'MG', label: 'Minas Gerais' },
  { value: 'SP', label: 'São Paulo' },
  { value: 'RJ', label: 'Rio de Janeiro' },
  { value: 'PE', label: 'Pernambuco' },
  { value: 'BA', label: 'Bahia' },
  { value: 'CE', label: 'Ceará' },
  { value: 'RS', label: 'Rio Grande do Sul' },
  { value: 'PR', label: 'Paraná' },
];

export const mockCityOptions: ComboboxOption[] = [
  { value: 'Belo Horizonte', label: 'Belo Horizonte' },
  { value: 'Contagem', label: 'Contagem' },
  { value: 'Uberlândia', label: 'Uberlândia' },
  { value: 'São Paulo', label: 'São Paulo' },
  { value: 'Campinas', label: 'Campinas' },
  { value: 'Rio de Janeiro', label: 'Rio de Janeiro' },
  { value: 'Recife', label: 'Recife' },
  { value: 'Salvador', label: 'Salvador' },
];

export const emptyValues: JobEditConditionsValues = {
  contractType: '',
  workModels: [],
  requirementStates: [],
  requirementCities: [],
  workplaceCities: [],
  relocationAvailability: '',
  relocationScope: [],
  travelAvailability: '',
  travelScope: [],
  shifts: [],
  weeklyHoursList: [],
};

export const filledValues: JobEditConditionsValues = {
  contractType: 'estagio',
  // EU-497 — múltipla escolha.
  workModels: ['hibrido', 'presencial'],
  requirementStates: ['MG', 'SP'],
  requirementCities: ['Belo Horizonte', 'São Paulo'],
  workplaceCities: ['Belo Horizonte - MG'],
  relocationAvailability: 'sim',
  relocationScope: ['dentro-do-brasil'],
  travelAvailability: 'nao',
  travelScope: [],
  shifts: ['matinal', 'integral'],
  weeklyHoursList: ['30', '40'],
};

export const remoteValues: JobEditConditionsValues = {
  ...filledValues,
  workModels: ['remoto'],
};

const baseProps: Omit<JobEditConditionsPageProps, 'values'> = {
  jobName: 'Desenvolvimento de softwares',
  errors: {},
  contractTypeOptions: [
    { value: 'banco-de-talentos', label: 'Banco de talentos' },
    { value: 'estagio', label: 'Estágio' },
  ],
  optionalFields: [],
  isSubmitting: false,
  stateOptions: mockStateOptions,
  cityOptions: mockCityOptions,
  workplaceCityOptions: mockCityOptions,
  workplaceSearchLoading: false,
  onWorkplaceSearchChange: () => undefined,
  onFieldChange: () => undefined,
  onBack: () => undefined,
  onSubmit: () => undefined,
};

export const emptyProps: JobEditConditionsPageProps = {
  ...baseProps,
  values: emptyValues,
};

export const filledProps: JobEditConditionsPageProps = {
  ...baseProps,
  values: filledValues,
};

export const remoteProps: JobEditConditionsPageProps = {
  ...baseProps,
  values: remoteValues,
};
